module.exports = __webpack_public_path__ + "img/firefly-header.bcde5c07.png";